module.exports = __webpack_public_path__ + "img/gw.d5d81c3a.svg";